/* eslint-disable */

import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';


const TopicToolsSticky = (props) => {
  const { pathname } = props;
  const [displayRefinedSearch, setDisplayRefinedSearch] = useState(false);
  const [displayTopicTools, setDisplayTopicTools] = useState(false);
  useEffect(() => {
    $('a#back-top').on("click",function() {
      $('body,html').animate({scrollTop: 0}, 800);            
      return false;
    });
    $("#bottomSticky").hide();

    $(window).on("scroll",function () {
      if ($(this).scrollTop() > 160) {
        $('#bottomSticky').fadeIn();
      } else {
        $('#bottomSticky').fadeOut();
      }
    });
    $(".modal-backdrop").hide();

    /* PAGE FUNCTIONALITIES */
    $('#refineSearchbtn').on('click', function(e) {
      $('.searchContainer .slider-arrow').click();
      $('#bottomSticky').css("display","block");
    });
  }, []);

  useEffect(() => {
    if (pathname.includes('viewTopic') || pathname.includes('topicTeaser')) {
      setDisplayRefinedSearch(false);
      setDisplayTopicTools(true);
    } else if (pathname.includes('searchAction')) {
      setDisplayRefinedSearch(true);
      setDisplayTopicTools(false);
    }
  }, [pathname]);

  return (
    <div id="bottomSticky">
      <a id="back-top" href="#" style={{ display: 'block', fontSize: '19.5px' }} title="Back To Top">
        <span className="fa-stack">
          <i className="fa fa-circle fa-stack-2x fa-inverse" style={{ color: '#f4f4f4' }}></i>
          <i className="fa fa-arrow-up fa-stack-1x"></i>
        </span>
      </a>
      { false && displayRefinedSearch && (
        <a id="refineSearchbtn" className="btmsticky" title="Refine Search" onClick={(e) => {e.preventDefault()}}>Refine search</a>
      )}
      { false && displayTopicTools && (
        <ul className="topic-icons showIcon topicButtons mobile" style={{ float: 'none', position: 'fixed', bottom: '9px', left: '19px' }}>
          <li>
            <a className="btmsticky expertgroup" data-tooltip="true" data-toggle="modal" data-placement="bottom" data-target="#expertgroup" title="Expert Group" data-original-title="Expert Group" onClick={(e) => {e.preventDefault()}}></a>
          </li>
          <li className="printMobile" style={{ paddingLeft: '7px' }}>
            <a className="btmsticky print" data-tooltip="true" data-placement="bottom" title="Print Topic" data-original-title="Print topic" onClick={(e) => {e.preventDefault()}}></a>
          </li>
          <li style={{ paddingLeft: '7px' }}>
            <a className="togglefontsize toggleFontSize" data-tooltip="true" data-placement="bottom" title="Toggle Font Size" data-original-title="Toggle Font Size" onClick={(e) => {e.preventDefault()}}></a>
          </li>
        </ul>
      )}
    </div>
  )
}

export default TopicToolsSticky;
